import { fg } from '@atlaskit/platform-feature-flags';
import { conditionalHooksFactory } from '@atlaskit/platform-feature-flags-react';

import { useGlobalShortcutsDataBFF } from './useGlobalShortcutsDataBFF';
import { useGlobalShortcutsDataQuery } from './useGlobalShortcutsDataQuery';
export { useGlobalShortcutsDataRelay } from './useGlobalShortcutsDataRelay';

export const useGlobalShortcutsData = conditionalHooksFactory(
	() => fg('navx-4463-gas-agg-migration'),
	useGlobalShortcutsDataQuery,
	useGlobalShortcutsDataBFF,
);
